export default "__VITE_ASSET__06b9add6__"